import Form from 'react-bootstrap/Form';
import React, { useState, useEffect } from 'react';
import { _eval } from "../utils";
import BaseField from './BaseField';

function StringInput(props) {

    const [charCount, setCharCount] = useState(0);
    const [showError, setShowError] = useState(false);

    const handleChange = (v) => {

        setCharCount(v.length)

        // Check if we must map the field
        const map = (() => {
            if (_eval(props, 'data', 'map'))
                return props.data.map
            else
                return false
        })()

        // regex checker
        const regexPass = (() => {
            if (v.length < 3) return false // don't live check field if input is below 3 chars
            else if (props.data.pattern) {
                const re = new RegExp(props.data.pattern);
                return !re.test(v)
            }
            else return false
        })()
        setShowError(regexPass)

        // If we must keep the label in the value,
        // concat the label with the value
        if (_eval(props, 'data', 'keepLabel'))
            if (props.data.keepLabel === true)
                v = props.data.label + ' -> ' + v


        // send data to parent
        props.handleChange(props.data.sid, { value: v, validity: !regexPass, map: map })
    }


    return (
        <BaseField
            data={props.data}
            handleChange={props.handleChange}
            formData={props.formData}
        >

            {props.data.label.length > 0 ?
                <Form.Label htmlFor={`input-for-${props.data.sid}`}>
                    {props.data.label}
                    {props.data.required ?
                        <span className='text-danger'>&nbsp;*</span>
                        : null}
                </Form.Label>
                : null}

            <Form.Control
                value={props.data.value || ''}
                required={props.data.required}
                autoComplete={props.data.sid === 'EMAIL' ? 'off' : 'on'} // DEBUG: disable autocomplete for email fields (some user email field are skipped by the app. Guessing it's because of the autocomplete)
                type={props.data.type}
                pattern={props.data.pattern ? props.data.pattern : undefined}
                id={`input-for-${props.data.sid}`}
                aria-describedby={`helper-for-${props.data.sid}`}
                onChange={e => { props.data.value = e.target.value; handleChange(e.target.value) }}
                data-validity-selector={props.data.sid}
                maxLength={props.data.max ? props.data.max : -1}
            />

            {props.data.max ?
                <div className='text-muted text-end'><small>{charCount + '/' + props.data.max}</small></div>
                : null}

            {props.data.helper ?
                <Form.Text id={`helper-for-${props.data.sid}`} muted dangerouslySetInnerHTML={{ __html: props.data.helper }} />
                : null}

            {/* Field live check */}
            {props.data.error && showError ?
                <div>
                    <Form.Text id={`error-for-${props.data.sid}`} className='text-danger'>
                        {props.data.error}
                    </Form.Text>
                </div>
                : null}

            {/* Field check validity on submit */}
            {!(props.data.error && showError) ?
                <Form.Control.Feedback type="invalid">
                    {props.data.error}
                </Form.Control.Feedback>
                : null}

        </BaseField>
    );
}

export default StringInput;